module.exports = __webpack_public_path__ + "8202100959a619f85120a44de4cb0b3f.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances/mambo.mp3
// module id = 4153
// module chunks = 0